module.exports = __webpack_public_path__ + "static/media/pexels-gül-işık-13794311.0aee1895.jpg";